var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    contentScriptType: "text/ecmascript",
    height: 2048,
    viewBox: "45 0 966 2048",
    width: 966,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627 1504c0 8.667-3.333 16.333-10 23l-50 50c-6.667 6.667-14.333 10-23 10s-16.333-3.333-23-10L55 1111c-6.667-6.667-10-14.333-10-23s3.333-16.333 10-23l466-466c6.667-6.667 14.333-10 23-10s16.333 3.333 23 10l50 50c6.667 6.667 10 14.333 10 23s-3.333 16.333-10 23l-393 393 393 393c6.667 6.667 10 14.333 10 23zm384 0c0 8.667-3.333 16.333-10 23l-50 50c-6.667 6.667-14.333 10-23 10s-16.333-3.333-23-10l-466-466c-6.667-6.667-10-14.333-10-23s3.333-16.333 10-23l466-466c6.667-6.667 14.333-10 23-10s16.333 3.333 23 10l50 50c6.667 6.667 10 14.333 10 23s-3.333 16.333-10 23l-393 393 393 393c6.667 6.667 10 14.333 10 23z"
  })));
};

export default SvgIconChevronLeft;